import React, { useCallback, useEffect, useState } from "react"
import * as caseStudyStyle from "./styles.module.scss"
import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { isBrowser } from "../../util/general"


const FixedNav = ({ caseStudies, previous, next, mod }) => {
  const [state, setState] = useState({
    scrollAt: isBrowser && window.scrollY,
    top: isBrowser && window.scrollY === 0,
    className: `${caseStudyStyle.caseStudiesNavigation} ${caseStudyStyle.isFixed}`,
  })

  const handleScroll = useCallback(() => {
      const caseStudyFullHeight = document.getElementById("caseStudy")
        .offsetHeight
      let scrollPosition = window.innerHeight + window.scrollY

      const scrollAt = window.scrollY
      const scrollingDown = state.scrollAt < window.scrollY
      const notAtBottom = scrollPosition < caseStudyFullHeight
      let className = ""

      if (state) {
        className = `${caseStudyStyle.caseStudiesNavigation}`
        className +=
          scrollingDown && !state.top ? ` ${caseStudyStyle.showNavBar}` : ""
        className += notAtBottom
          ? ` ${caseStudyStyle.isFixed} ${
              scrollAt !== 0
                ? caseStudyStyle.isVisible
                : caseStudyStyle.hideNavBar
            }`
          : ` ${caseStudyStyle.isAbsolute}`
      } else {
        className = `${caseStudyStyle.caseStudiesNavigation} ${caseStudyStyle.isFixed}`
      }

      setState({
        scrollAt,
        className,
        top: window.scrollY === 0 || state.top,
      })
  }, [state, setState])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true)

    return () => {
      window.removeEventListener("scroll", handleScroll, true)
    }
  }, [handleScroll]);

  const navigationArrow = getImage(mod.navigationArrow)

  return (
    <div id="caseStudyNavigation" className={state.className}>
      <span className={caseStudyStyle.desktopVersion}>
        {caseStudies.map(item => (
          <Link
            className={
              mod.slug === item.link
                ? `${caseStudyStyle.toggle} ${caseStudyStyle.notActive}`
                : `${caseStudyStyle.toggle}`
            }
            to={`/our-work${item.link}`}
            key={item.link}
          >
            <div className={caseStudyStyle.textLeft}>
              <h4 className={caseStudyStyle.toggleTextBold}>{item.name}</h4>
            </div>
          </Link>
        ))}
      </span>
      <span className={caseStudyStyle.mobileVersion}>
        <div className={caseStudyStyle.previousAndNextButtons}>
          <Link
            className={caseStudyStyle.toggle}
            to={`/our-work${previous.link}`}
          >
            <GatsbyImage
              className={caseStudyStyle.toggleIconLeft}
              alt={mod.navigationArrow.title}
              image={navigationArrow}
            />
            <div className={caseStudyStyle.textLeft}>
              <h4 className={caseStudyStyle.toggleTextBold}>
                {next.name}
              </h4>
            </div>
          </Link>
          <Link
            className={caseStudyStyle.toggle}
            to={`/our-work${next.link}`}
          >
            <div className={caseStudyStyle.textRight}>
              <h4 className={caseStudyStyle.toggleTextBold}>
                {next.name}
              </h4>
            </div>
            <GatsbyImage
              className={caseStudyStyle.toggleIconRight}
              alt={mod.navigationArrow.title}
              image={navigationArrow}
            />
          </Link>
        </div>
      </span>
    </div>
  )
}

export default FixedNav
